"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DailyStreakUtil = exports.createDefaultDailyStreak = exports.DAILY_STREAK_EXPIRATION_THRESHOLD = exports.DailyStreakStatus = void 0;
exports.getDailyRewardPiggyBanks = getDailyRewardPiggyBanks;
exports.getDailyRewardBonusPiggyBanks = getDailyRewardBonusPiggyBanks;
const types_1 = require("../types");
var DailyStreakStatus;
(function (DailyStreakStatus) {
    DailyStreakStatus["READY_FOR_AD"] = "READY_FOR_AD";
    DailyStreakStatus["CLAIMED"] = "CLAIMED";
    DailyStreakStatus["EXPIRING"] = "EXPIRING";
    /** This is effectively the same as READY_FOR_AD except that the raw data hasn't been reset yet (i.e. streakCount field would be non-zero) */
    DailyStreakStatus["EXPIRED"] = "EXPIRED";
})(DailyStreakStatus || (exports.DailyStreakStatus = DailyStreakStatus = {}));
const millisInDay = 24 * 60 * 60 * 1000;
exports.DAILY_STREAK_EXPIRATION_THRESHOLD = 3 * millisInDay;
const createDefaultDailyStreak = () => {
    return {
        streakCount: 0,
        lastAdWatch: null,
    };
};
exports.createDefaultDailyStreak = createDefaultDailyStreak;
class DailyStreakUtil {
    constructor(streak, rewards) {
        this.streak = streak;
        this.rewards = rewards;
    }
    getStreakStatus(time) {
        if (!this.streak.lastAdWatch) {
            return DailyStreakStatus.READY_FOR_AD;
        }
        const nextRewardsMs = this.getNextReward(time);
        if (nextRewardsMs > 0) {
            return DailyStreakStatus.CLAIMED;
        }
        if (-nextRewardsMs < millisInDay) {
            return DailyStreakStatus.READY_FOR_AD;
        }
        if (-nextRewardsMs < exports.DAILY_STREAK_EXPIRATION_THRESHOLD) {
            return DailyStreakStatus.EXPIRING;
        }
        return DailyStreakStatus.EXPIRED;
    }
    /** Gets the time offset in milliseconds until the next ad watch / reward is available.
     * If the value is negative then that is the number of milliseconds since it has
     * been available. */
    getNextReward(time) {
        if (!this.streak.lastAdWatch) {
            return 0;
        }
        const lastAdWatchDate = types_1.FTimestampFunc.toDate(this.streak.lastAdWatch);
        const nextRewardTime = new Date(lastAdWatchDate);
        nextRewardTime.setUTCHours(this.getNormalizedResetOffset(), 0, 0, 0);
        if (lastAdWatchDate.getUTCHours() >= this.getNormalizedResetOffset()) {
            nextRewardTime.setDate(nextRewardTime.getDate() + 1);
        }
        return nextRewardTime.getTime() - time.getTime();
    }
    /** Gets the time until the streak will fully expire */
    getStreakExtensionEnd(time) {
        const timeTillNextReward = this.getNextReward(time);
        return exports.DAILY_STREAK_EXPIRATION_THRESHOLD + timeTillNextReward;
    }
    /** Gets a positive UTC offset in the range of [0,23] */
    getNormalizedResetOffset() {
        const cappedRange = this.rewards.resetTimeUTCOffset % 24;
        return cappedRange < 0 ? 24 + cappedRange : cappedRange;
    }
    getNextRewardPiggyBanks() {
        return getDailyRewardPiggyBanks(this.streak.streakCount + 1, this.rewards);
    }
}
exports.DailyStreakUtil = DailyStreakUtil;
function getDailyRewardPiggyBanks(streakCount, rewards) {
    if (streakCount <= 0) {
        return 0;
    }
    return rewards.defaultPiggyBanks + getDailyRewardBonusPiggyBanks(streakCount, rewards);
}
function getDailyRewardBonusPiggyBanks(streakCount, rewards) {
    if (streakCount <= 0) {
        return 0;
    }
    function findMaxBonusDay(bonusDays) {
        const numberArray = bonusDays.map(Number);
        return Math.max(...numberArray);
    }
    // After max bonus day, the rewards repeat every 30 days
    const bonusDays = Object.keys(rewards.bonusDayPiggyBanks);
    const maxBonusDay = findMaxBonusDay(bonusDays);
    const nextDayFromMaxBonusDay = maxBonusDay + 1;
    const normalizedCount = streakCount <= maxBonusDay
        ? streakCount
        : nextDayFromMaxBonusDay - 30 + ((streakCount - nextDayFromMaxBonusDay) % 30);
    if (rewards.bonusDayPiggyBanks[normalizedCount]) {
        return rewards.bonusDayPiggyBanks[normalizedCount];
    }
    return 0;
}
